<template>
  <div>
    <b-form inline @submit.prevent="" class="mb-2">
      <b-input-group class="filter-group">
        <b-input-group-prepend is-text class="semester-input-group">
          Semester
        </b-input-group-prepend>
        <b-form-select v-model="term"
                      @input="changeTerm" 
                      :options="terms"
                      value-field="termId"
                      text-field="description"
                      />
      </b-input-group>

      <b-input-group class="filter-group ml-2">
        <b-input-group-prepend is-text class="semester-input-group">
          Limit
        </b-input-group-prepend>
        <b-input v-model="limit" @input="changeTerm" type="number" />
      </b-input-group>
    </b-form>
    <div>
    <items-per-term :items="items"/>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import opportunityReportsApi from "../../api/opportunityReporting";
import termsApi from "../../api/terms";
import ItemsPerTerm from "../../components/dashboard/items-per-term";
export default {
  data() {
    return {
      items: {},
      terms: [],
      term: null,
      limit: 10
    };
  },
  components: {
    ItemsPerTerm
  },
  methods: {
    changeTerm() {
      this.getData();
    },
    getData() {
      opportunityReportsApi
        .getSitePopularity(this.term, this.limit)
        .then(response => {
          this.items = response.data;
        });
    }
  },
  created() {
    termsApi.getPastTerms().then(response => {
      this.terms = response.data;
    });
    this.getData();
  }
};
</script>

<style scoped>
</style>
